<template>
  <div class="page-fonts">
    <div class="current-font">
      <p>Body Text and Links</p>
      <strong>{{bodyFont}}</strong>
      <Btn
        tertiary
        @click="activateFontPreviewer('body')">
        Change
      </Btn>
    </div>

    <div class="current-font">
      <p>Titles and Headings</p>
      <strong>{{headingFont}}</strong>
      <Btn
        tertiary
        @click="activateFontPreviewer('heading')">
        Change
      </Btn>
    </div>

    <Field
      label="Heading Font"
      hidden
      @input="$v.resource.font_heading.$touch()"
      v-model="resource.font_heading"
      :error="font_headingError"/>

    <Field
      label="Body Font"
      hidden
      @input="$v.resource.font_body.$touch()"
      v-model="resource.font_body"
      :error="font_bodyError"/>

    <FontPreviewer
      v-if="headingFontActive"
      type="font_heading"
      @closeOverlay="closeOverlay"
      @setFont="setFont"/>

    <FontPreviewer
      v-if="bodyFontActive"
      type="font_body"
      @closeOverlay="closeOverlay"
      @setFont="setFont"/>
  </div>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import FontPreviewer from '@/components/FontPreviewer'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'site-fonts-form',

  mixins: [form],

  data() {
    return {
      font_heading: {},
      font_body: {},
      headingFontActive: false,
      bodyFontActive: false
    }
  },

  components: {
    Btn,
    FontPreviewer
  },

  props: {
    companyId: String,
    siteId: String
  },

  computed: {
    ...errorMessages([
      'font_heading',
      'font_body'
    ]),

    bodyFont() {
      return this.resource.font_body ? this.resource.font_body.family : 'Default'
    },

    headingFont() {
      return this.resource.font_heading ? this.resource.font_heading.family : 'Default'
    }
  },

  validations: {
    resource: {
      font_heading: {required},
      font_body: {required}
    }
  },

  methods: {
    setFont(type, font) {
      this.resource[type] = font
      this.closeOverlay()
      this.$emit('submit')
    },

    closeOverlay() {
      this.headingFontActive = false
      this.bodyFontActive = false
    },

    activateFontPreviewer(type) {
      this[type + 'FontActive'] = true
    }
  }
}
</script>

<style lang="sass" scoped>
.current-font
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
</style>
